import { css, Theme } from '@emotion/react'

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const title = css`
  font-weight: 700;
`

export const groupTitle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`

export const circle = (color: string) => css`
  background: ${color};
  width: 8px;
  height: 8px;
  border-radius: 50%;
`

export const titleColor = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: start;
  column-gap: 14px;
  row-gap: 10px;
`

export const menuItemColor = (color: string) => css`
  width: 24px;
  height: 24px;
  background: ${color};
  border-radius: 38px;
`

export const icon = (theme: Theme) => css`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  background: ${theme.backgrounds.backgroundFive};
  box-sizing: border-box;
`

export const menuItem = css`
  padding-right: 7px;
  padding-left: 7px;
`
